import { useNavigator } from '@repo/toolkit/use-navigator'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createOlHostFamilyPrice } from '../../../api/ols/host-family-prices/create-ol-host-family-price'
import OlHostFamilyPriceForm from '../../../components/pages/ols/ol-host-family-prices/ol-host-family-price-form'
import { Paths } from '../../../lib/constants/path'
import { CurrencyEnum } from '../../../lib/types/enums/common/currency.enum'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { constructOlPath } from './utils'

type Props = {
  olId: number
}

const OlHostFamilyPriceCreate: React.FC<Props> = ({ olId }) => {
  const { back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createOlHostFamilyPrice,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Prix de la famille hôtelière créé avec succès')
      back(constructOlPath(Paths.OL_DETAILS_HOST_FAMILY_PRICES_PAGE, olId))
    }
  })

  return (
    <OlHostFamilyPriceForm
      mode="create"
      olId={olId}
      defaultValues={{ currency: CurrencyEnum.EUR }}
      buttonsConfig={twoButtonsConfig({
        onConfirm: async (values) => {
          await mutateAsync({
            id: olId,
            ...values
          })
        },
        onCancel: () => back(constructOlPath(Paths.OL_DETAILS_HOST_FAMILY_PRICES_PAGE, olId))
      })}
    />
  )
}

export default OlHostFamilyPriceCreate
